import { I_Alert } from "../components/icons";
import { glassDeep, heading } from "../styles.js";

const ErrorScreen = ({ title, msg }) => (
    <div className="min-h-screen flex items-center justify-center p-5 text-slate-100">
      <div className={`${glassDeep} max-w-xl rounded-2xl p-8 shadow-2xl`}>
        <div className="w-12 h-12 rounded-xl bg-rose-500/10 text-rose-300 flex items-center justify-center mb-5 ring-1 ring-rose-500/20">
          <I_Alert size={22} />
        </div>
        <h1 className="text-2xl mb-3 text-slate-100" style={heading}>
          {title || "Estatebook couldn't start"}
        </h1>
        <p className="text-sm text-slate-300 leading-relaxed">{msg}</p>
      </div>
    </div>
  );

export { ErrorScreen };
